module.exports = __webpack_public_path__ + "img/Elements_Icons_Asset Profiles.97004aeb.png";